export type KnowledgeDiscoveryJiraSearchExperienceType =
	(typeof KnowledgeDiscoveryJiraSearchExperience)[keyof typeof KnowledgeDiscoveryJiraSearchExperience];

/**
 * Experience type for Jira search intent.
 */
export const KnowledgeDiscoveryJiraSearchExperience = {
	QUICK_FIND: 'QUICK_FIND',
} as const;
